import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { getDollarFormat, roundToDecimalPlace } from 'utils/helpers';
import NoDataMsg from 'library/noData';
import { ResponsiveContainer, Line, LineChart, XAxis, YAxis, CartesianGrid, Tooltip, Legend, BarChart, Bar } from "recharts";
import CheckInput from 'screens/components/basic/CheckInput';
import { formatNumbers } from 'utils/helpers';
import SelectInput from 'screens/components/basic/SelectInput';
import Pagination from 'screens/components/basic/Pagination';

const componentName = "AggregateBranchSalesInventory";
class Body extends Component {

    constructor(props) {
        super(props);

        this.state = {
            chartCurrentPage: 1
        }

        this.branchesPerPage = 10;
    }

    generateSummaryRows = (data, prevPeriodData) => {
        let outputList = [];
        let nameList = [
            { name: "Gross Sales", key: "grossSales", format: "$" },
            { name: "Net Sales", key: "netSales", format: "$" },
            { name: "Exact Costs", key: "exactCosts", format: "$" },
            { name: "Items Sold", key: "itemsSold", format: "none" },
            { name: "Gross Profit", key: "grossProfitExact", format: "$" },
            { name: "Gross Profit %", key: "grossProfitPercent", format: "%" }
        ]

        nameList.forEach(item => {
            let columns = []
            data.forEach(branchItem => {

                columns.push(<td>{formatNumbers(branchItem[`${item.key}`], item.format)}</td>)

                if (prevPeriodData.length > 0) {
                    let prevData = prevPeriodData.filter(prevBranchItem => prevBranchItem.branchId == branchItem.branchId)
                    let yoy = prevData.length > 0 ? (branchItem[`${item.key}`] - prevData[0][`${item.key}`]) / prevData[0][`${item.key}`] * 100 : 0
                    columns.push(<td className={yoy >= 0 ? "green-text" : "red-text"}>{formatNumbers(roundToDecimalPlace(yoy, 1), "%")}</td>)
                }

            })
            outputList.push(
                <tr key={item.branchId}>
                    <td><b>{item.name}</b></td>
                    {
                        columns
                    }

                </tr>
            )
        }
        );
        return outputList
    }

    generateDetailRows = (data, branches) => {

        let dateList = new Set(data.map(item => item.date));
        let outputList = [];

        dateList.forEach(date => {
            let branchDataList = []
            branches.forEach(branch => {
                let branchData = data.filter(item => item.date == date && item.branchId == branch.value)
                branchDataList.push(
                    <td key={`${date}${branch.value}`}>{branchData.length > 0 ? formatNumbers(branchData[0].netSales, "$") : "$0"}</td>
                )
            })

            outputList.push(
                <tr key={date}>
                    <td><b>{moment(date).format('YYYY MMM DD')}</b></td>
                    {
                        branchDataList
                    }
                </tr>

            )
        })

        return outputList
    }

    getDataForPlotting = (data, column, branches) => {

        let dateList = new Set(data.map(item => item.date));
        let outputList = [];

        dateList.forEach(date => {
            let dateData = { date: date };
            branches.forEach(branch => {
                let branchData = data.filter(item => item.date == date && item.branchId == branch.value)

                switch (column) {
                    case "netSales":
                        dateData[`${branch.text}`] = branchData.length > 0 ? branchData[0].netSales : 0;
                        break;
                    case "inventoryValue":
                        dateData[`${branch.text}`] = branchData.length > 0 ? branchData[0].totalValue : 0;
                        break;
                }
            })

            outputList.push(
                dateData
            )
        })

        return outputList
    }

    generateBars = (branches) => {
        let colors = ['#7a60e5', '#009CE0', '#16A5A5', '#68BC00', '#B0BC00', '#FCC400', '#E27300', '#D33115', '#FA28FF', '#AEA1FF', '#73D8FF', '#68CCCA', '#A4DD00', '#DBDF00', '#FCDC00', '#FE9200', '#F44E3B', '#FDA1FF', '#653294', '#0062B1', '#0C797D', '#194D33', '#808900', '#FB9E00', '#C45100', '#9F0500', '#AB149E'];
        let bars = []

        const firstItemInPage = (this.state.chartCurrentPage - 1) * this.branchesPerPage;

        branches.slice(firstItemInPage, firstItemInPage + this.branchesPerPage).forEach((branch, index) => {
            bars.push(
                <Bar dataKey={branch.text} fill={colors[index]} />
            )
        })

        return bars
    }

    wrangleData = (data, branches) => {
        let summary = data ? data.filter(item => item.recordType == "Summary") : [];
        let perBranchSummary = data ? data.filter(item => item.recordType == "Per Branch Summary") : [];
        let finalsummary = summary.concat(perBranchSummary);

        let details = data ? data.filter(item => item.recordType == "Details") : [];
        let salesDataForPlotting = this.getDataForPlotting(details, "netSales", branches);
        let inventoryDataForPlotting = this.getDataForPlotting(details, "inventoryValue", branches);

        return [finalsummary, details, salesDataForPlotting, inventoryDataForPlotting]
    }

    generateMoMData = (currentData, prevPeriodData, selectedBranchText) => {

        let outputList = [];

        currentData.forEach(item => {
            let dateData = { date: item.date };
            dateData[`${moment(item.date).format("YYYY")}`] = item[`${selectedBranchText}`]

            let prevData = prevPeriodData.filter(prevItem => moment(prevItem.date).format("MMMM") == moment(item.date).format("MMMM"))
            dateData[`${moment(item.date).format("YYYY") - 1}`] = prevData.length > 0 ? prevData[0][`${selectedBranchText}`] : 0;

            outputList.push(
                dateData
            )
        })

        return outputList

    }

    handleChartPageChange = (page) => {
        this.setState({ chartCurrentPage: page });
    }

    render() {
        let aggregateBranchSalesInventory = this.props.aggregateBranchSalesInventory;
        let beginDate = this.props.beginDate;
        let endDate = this.props.endDate;
        let uniqueBranchIdsSales = aggregateBranchSalesInventory && aggregateBranchSalesInventory.data ?
            Array.from(new Set(aggregateBranchSalesInventory.data.filter(item => item.recordType == "Per Branch Summary"
            ).map(item => item.branchId))).sort((a, b) => a - b) : []
        let branchesSales = this.props.branches.filter(item => uniqueBranchIdsSales.includes(parseInt(item.value)))

        let uniqueBranchIdsInventory = aggregateBranchSalesInventory && aggregateBranchSalesInventory.data ?
            Array.from(new Set(aggregateBranchSalesInventory.data
                .map(item => item.branchId))).sort((a, b) => a - b) : []
        let branchesInventory = this.props.branches.filter(item => uniqueBranchIdsInventory.includes(parseInt(item.value)))

        let currentData = aggregateBranchSalesInventory ? aggregateBranchSalesInventory.data : [];
        let [finalsummary, details, salesDataForPlotting, inventoryDataForPlotting] = this.wrangleData(currentData, branchesSales);

        let [prevPeriodData, prevFinalsummary, prevDetails, prevSalesDataForPlotting, moMPlotData, _] = [[], [], [], [], [], []]

        if (aggregateBranchSalesInventory && aggregateBranchSalesInventory.selectedDateRangeType == "last2years") {
            prevPeriodData = aggregateBranchSalesInventory ? aggregateBranchSalesInventory.prevPeriodData : [];
            [prevFinalsummary, prevDetails, prevSalesDataForPlotting, _] = this.wrangleData(prevPeriodData, branchesSales);
            moMPlotData = this.generateMoMData(salesDataForPlotting, prevSalesDataForPlotting, this.props.plotBranchSelectionText);
        }

        return (
            <div className="row m-0">
                {
                    details.length <= 0 ?
                        //If there's NO DATA to display
                        <NoDataMsg />
                        :
                        details.length > 0 &&
                        //If there's DATA
                        <div>
                            {/* Date */}
                            <div className="row m-0">
                                <div className="text-center list_header">
                                    {aggregateBranchSalesInventory && aggregateBranchSalesInventory.selectedDateRangeType == "last2years" ?
                                        <p><i>From</i> <b>{moment().subtract(1, 'year').startOf('year').format('MMMM Do, YYYY')}</b> <i> to </i>
                                            <b>{moment().subtract(1, 'year').endOf('year').format('MMMM Do, YYYY')}</b></p>
                                        :
                                        beginDate ?
                                            <p><i>From</i> <b>{moment(beginDate).format('MMMM Do, YYYY')}</b> <i> to </i>
                                                {endDate ? <b>{moment(endDate).format('MMMM Do, YYYY')}</b> : moment().format('MMMM Do, YYYY')}</p>
                                            : ""}
                                </div>
                            </div>
                            {/* Summary */}
                            <div className="col-lg-12 mt-1 flex-column justify-content-lg-center">
                                <div className="col-lg-12 title_summary">
                                    <h3 className="m-0 text-center text-justify">SUMMARY</h3>
                                </div>
                                <div className="col-lg-12 p-0 mb-2" style={{ overflowX: "auto" }}>
                                    <table className="table table-striped table-hover table-responsive table-fixed m-0">
                                        <thead>
                                            <tr>
                                                <th className="tableHeaderColorPurple"></th>
                                                <th className="tableHeaderColorPurple">Total</th>
                                                {aggregateBranchSalesInventory && aggregateBranchSalesInventory.selectedDateRangeType == "last2years" ?
                                                    <th className="tableHeaderColorPurple">YoY</th> : null
                                                }
                                                {
                                                    branchesSales.map(item => {
                                                        return (
                                                            [<th className="tableHeaderColorPurple" key={item.text}>{item.text}</th>,
                                                            aggregateBranchSalesInventory && aggregateBranchSalesInventory.selectedDateRangeType == "last2years" ? <th className="tableHeaderColorPurple" key={`${item.text}YoY`}>YoY</th> : null]
                                                        )
                                                    })
                                                }
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.generateSummaryRows(finalsummary, prevFinalsummary)}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            {/* Detail */}
                            {aggregateBranchSalesInventory && aggregateBranchSalesInventory.selectedDateRangeType == "last2years" ?
                                <div className="col-lg-12">
                                    <div className="col-lg-12 title_summary">
                                        <h3 className="m-0 text-center text-justify">Month-over-Month (MoM)</h3>
                                    </div>
                                    <div className="col-lg-12">
                                        <h3 className="text-center">Net Sales</h3>
                                        <div className="col-lg-2 pull-right">
                                            <SelectInput
                                                defaultValue={branchesSales[0].value}
                                                name="plotBranchSelectionDropdown"
                                                fullWidth={true}
                                                options={branchesSales}
                                                className="categoryProductsPlotDropdown"
                                            />
                                        </div>
                                        <div className="col-lg-12 mt-2 bg-light" >
                                            <ResponsiveContainer width="100%" height={400}>
                                                <LineChart data={moMPlotData}>
                                                    <CartesianGrid />
                                                    <XAxis dataKey="date" tick={{ fontSize: 10 }} tickFormatter={value => moment(value).format('MMMM')} />
                                                    <YAxis tickFormatter={value => `$${value}`} />
                                                    <Tooltip labelFormatter={value => moment(value).format('MMMM')} formatter={value => `$${value}`} cursor={{ fill: "#D4D1FF20" }} />
                                                    <Line dataKey={new Date().getFullYear() - 1} stroke="#7a60e5" name={new Date().getFullYear() - 1} />
                                                    <Line dataKey={new Date().getFullYear() - 2} stroke="#009CE0" name={new Date().getFullYear() - 2} />
                                                    <Legend />
                                                </LineChart>
                                            </ResponsiveContainer>
                                            <br />
                                            <br />
                                        </div>
                                    </div>
                                </div> : null
                            }
                            <div className="col-lg-12">
                                <div className="col-lg-12 title_summary">
                                    <h3 className="m-0 text-center text-justify">Details</h3>
                                </div>
                                {aggregateBranchSalesInventory && aggregateBranchSalesInventory.includeInventoryValue == 1 ?
                                    <div className="col-lg-12">
                                        <h3 className="text-center">Inventory Value</h3>
                                        <p className="text-center">It will display a maximum of 10 stores.</p>
                                        <div className="col-lg-12 mt-2 bg-light" >
                                            <ResponsiveContainer width="100%" height={300}>
                                                <BarChart data={inventoryDataForPlotting}>
                                                    <CartesianGrid />
                                                    <XAxis dataKey="date" tick={{ fontSize: 10 }} tickFormatter={value => moment(value).format('YYYY-MM-DD')} />
                                                    <YAxis tickFormatter={value => `$${value}`} />
                                                    <Tooltip labelFormatter={value => moment(value).format('YYYY-MM-DD')} formatter={value => `$${value}`} cursor={{ fill: "#D4D1FF20" }} />
                                                    <Legend />
                                                    {this.generateBars(branchesInventory)}
                                                </BarChart>
                                            </ResponsiveContainer>
                                            <br />
                                            <br />
                                        </div>
                                    </div> : null
                                }
                                {/* Chart */}
                                <div className="col-lg-12">
                                    <h3 className="text-center">Net Sales</h3>
                                    <div className="col-lg-12 mt-2 bg-light" >
                                        <ResponsiveContainer width="100%" height={300}>
                                            <BarChart data={salesDataForPlotting}>
                                                <CartesianGrid />
                                                <XAxis dataKey="date" tick={{ fontSize: 10 }} tickFormatter={value => moment(value).format('YYYY-MM-DD')} />
                                                <YAxis tickFormatter={value => `$${value}`} />
                                                <Tooltip labelFormatter={value => moment(value).format('YYYY-MM-DD')} formatter={value => `$${value}`} cursor={{ fill: "#D4D1FF20" }} />
                                                <Legend />
                                                {this.generateBars(branchesSales)}
                                            </BarChart>
                                        </ResponsiveContainer>
                                        <Pagination
                                            length={(branchesSales.length || 0)}
                                            itemsPerPage={this.branchesPerPage}
                                            activePage={this.state.chartCurrentPage}
                                            onPageChange={(e) => this.handleChartPageChange(e)}
                                            maxButtons={4}
                                            isChart={true} />
                                        <br />
                                        <br />
                                    </div>
                                </div>
                                {/* Table */}
                                <div className="col-lg-12" style={{ overflowX: "auto" }}>
                                    <table className="table table-striped table-hover table-responsive">
                                        <thead>
                                            <tr>
                                                <th className='tableHeaderColorGray'>Date</th>
                                                {
                                                    branchesSales.map(item => <th className="tableHeaderColorGray" key={item.text}>{item.text}</th>)
                                                }
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this.generateDetailRows(details, branchesSales)
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                }
            </div>
        )
    }
};

const mapStateToProps = state => {
    return {
        plotBranchSelectionText: state.form.plotBranchSelectionDropdownText
    };
};

const mapDispatchToProps = dispatch => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Body);


